import React from 'react';
import { actions } from '@ecosystem/newron-design-system';

const { Button } = actions;

interface SaveFilterButtonProps {
  onClick: () => void;
}

export function SaveFilterButton({ onClick }: SaveFilterButtonProps): JSX.Element {
  return (
    <Button mode="simple" onClick={onClick}>
      <Button.Icon>
        <Button.Icon.icons.BookmarkOutline />
      </Button.Icon>
      Save filter
    </Button>
  );
}
